'use client';

import { InputHTMLAttributes, forwardRef } from 'react';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, className = '', id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <label
        htmlFor={inputId}
        className="flex items-center gap-3 cursor-pointer select-none"
      >
        <input
          ref={ref}
          id={inputId}
          type="checkbox"
          className={`
            w-5 h-5 rounded border-zinc-600 bg-zinc-900/50
            text-amber-500 focus:ring-amber-500 focus:ring-2 focus:ring-offset-0
            cursor-pointer transition-colors
            ${className}
          `}
          {...props}
        />
        {label && (
          <span className="text-sm font-medium text-zinc-300">{label}</span>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;

